<div *ngIf="data.showFullBlock != true" style="padding: 20px;">
<div class="d-flex" style="justify-content: space-between;">
  <h2 style="position: relative;
    top: 21px;">Some orders could not be created</h2>
  <i
    class="fa fa-times close-icon"
    (click)="handleCancel2()"
    aria-hidden="true"
    data-bs-toggle="tooltip"
    title="Close"
  ></i>
    <!-- <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg> -->
</div>

<div mat-dialog-content>
  <div *ngFor="let invalidRow of groupedInvalidRows; let i = index" class="error-row">
    <!-- Error row with details -->
    <div class="invalid-row">
  Row {{ invalidRow.row_number }}
  |Order No: {{
  invalidRow.errors[0].order_no?.trim()
    ? invalidRow.errors[0].order_no
    : invalidRow.column_data.order_no
}}|
  <span class="error-message">{{ getCleanError(invalidRow.errors[0].message) }}</span>

  <div *ngFor="let error of invalidRow.errors.slice(1)" class="additional-error">
    Order No: {{ error.order_no }} |
    <span class="error-message">{{ getCleanError(error.message) }}</span>
  </div>
</div>


    <!-- Dropdown for selecting an address -->
    <div class="form-group dropdown-container" *ngIf="invalidRow.options?.length > 0">
      <label for="selectAddress-{{ i }}"> Select {{ invalidRow.isAddress ? 'Address' : 'Company' }}</label>
      <select
        id="selectAddress-{{ i }}"
        class="form-control"
        [(ngModel)]="invalidRow.selectedAddress"
        [ngClass]="{
          'is-invalid': !invalidRow.selectedAddress
        }"
      >
        <option value="" disabled selected>Select Category</option>
        <option *ngFor="let option of invalidRow.options" [value]="option">
          {{ option }}
        </option>
      </select>
      <i
      class="fa fa-copy px-2 copy-icon"
      (click)="copyText(invalidRow.selectedAddress)"
      matTooltip="Copy to clipboard"
      aria-hidden="true"
    ></i>
  </div>
</div>
  <div *ngIf="showstarcancelyes">
    <p class="mt-2">Do you want to add <strong>*</strong> to this Order No?</p>
   
  </div>
   <div *ngIf="showmergeorderModal">
    <!-- <p class="mt-2">Do you want to Merge existing order number order to the listing in multiple order ids?</p> -->
   
  </div>
<div mat-dialog-actions class="dialog-actions">
    <button *ngIf="showstarcancelno" mat-button mat-dialog-close style="position: relative; right: 20px;" class="no" (click)="handleCancel2()">No</button>
    <button *ngIf="showstarcancelyes" class="btn btn-sm  me-2 yes" (click)="handleAsteriskConfirmation()">Yes</button>
    <!-- <button *ngIf="showmergeorderModal" class="btn btn-sm  me-2 yes" (click)="handleCancel2()">Close</button> -->
    <button *ngIf="showmergeorderModal"  mat-button (click)="handleCancel()" style="position: relative; right: 20px;" class="no">No</button>
    <button *ngIf="showmergeorderModal" class="btn btn-sm  me-2 yes" (click)="handleAsteriskConfirmation()">Yes</button>

    <button *ngIf="starNotExist" mat-button (click)="handleCancel1()" style="position: relative; right: 20px;" class="no">Ok</button>
</div>
</div>
</div>
<div *ngIf="data.showFullBlock === true" style="padding: 20px;">
<div class="d-flex" style="justify-content: space-between;">
  <h2 style="position: relative;
    top: 17px;">This order could not be created</h2>
  <i
    class="fa fa-times close-icon"
    (click)="handleCancel2()"
    aria-hidden="true"
    data-bs-toggle="tooltip"
    title="Close"
  ></i>
</div>

<div mat-dialog-content>
  <div  class="error-row">
    <!-- Error row with details -->
    <div class="invalid-row">
      <!-- Order No: {{
  invalidRow.errors[0].order_no?.trim()
    ? invalidRow.errors[0].order_no
    : invalidRow.column_data.order_no
}}| -->
  <span class="error-message" >{{ this.data.invalidRows }}</span>

  <!-- <div *ngFor="let error of invalidRow.errors.slice(1)" class="additional-error">
    Order No: {{ error.order_no }} |
    <span class="error-message">{{ getCleanError(error.message) }}</span>
  </div> -->
</div>
</div>
  <div *ngIf="data?.add_star === true">
    <p class="mt-2">Do you want to add <strong>*</strong> to this Order No?</p>
   
  </div>
   <div *ngIf="showmergeorderModal">
    <!-- <p class="mt-2">Do you want to Merge existing order number order to the listing in multiple order ids?</p> -->
   
  </div>
<div mat-dialog-actions class="dialog-actions">
    <button *ngIf="showstarcancelno" mat-button mat-dialog-close style="position: relative; right: 20px;" class="no">No</button>
    <button *ngIf="showstarcancelyes" class="btn btn-sm  me-2 yes" (click)="handleAsteriskConfirmation()">Yes</button>
    <!-- <button *ngIf="showmergeorderModal" class="btn btn-sm  me-2 yes" (click)="handleCancel2()">Close</button> -->
    <button *ngIf="showmergeorderModal"  mat-button (click)="handleCancel()" style="position: relative; right: 20px;" class="no">No</button>
    <button *ngIf="showmergeorderModal"class="btn btn-sm  me-2 yes" (click)="handleAsteriskConfirmation()">Yes</button>

    <button *ngIf="starNotExist" mat-button (click)="handleCancel1()" style="position: relative; right: 20px;" class="no">Ok</button>
</div>
</div>
</div>